import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import {
  BlockMarkdownAdapterExtension,
  type MarkdownAST,
} from '@blocksuite/affine-shared/adapters';
import { nanoid } from '@blocksuite/store';

import { createEmbedBlockMarkdownAdapterMatcher } from '../../common/adapters/markdown.js';
import { videoUrlRegex } from '../embed-video-model.js';

const isLinkNode = (node: MarkdownAST): node is MarkdownAST & { url: string } =>
  node.type === 'link' && typeof (node as any).url === 'string';

export const embedVideoBlockMarkdownAdapterMatcher =
  createEmbedBlockMarkdownAdapterMatcher(EmbedVideoBlockSchema.model.flavour, {
    toMatch: o => {
      if (!isLinkNode(o.node)) return false;
      const raw = o.node.url ?? '';
      const url = raw.trim().replace(/^`|`$/g, '');
      return videoUrlRegex.test(url);
    },
    toBlockSnapshot: {
      enter: (o, context) => {
        if (!isLinkNode(o.node)) return;
        const { walkerContext } = context;
        const raw = o.node.url ?? '';
        const url = raw.trim().replace(/^`|`$/g, '');
        walkerContext
          .openNode(
            {
              type: 'block',
              id: nanoid(),
              flavour: EmbedVideoBlockSchema.model.flavour,
              props: {
                url,
              },
              children: [],
            },
            'children'
          )
          .closeNode();
        walkerContext.skipAllChildren();
      },
    },
  });

export const EmbedVideoMarkdownAdapterExtension = BlockMarkdownAdapterExtension(
  embedVideoBlockMarkdownAdapterMatcher
);
